export default {
  AUTH: "tristardj:auth"
}